(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VueContentLoading"] = factory();
	else
		root["VueContentLoading"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 11);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueContentLoading_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cc6ef6f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueContentLoading_vue__ = __webpack_require__(12);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueContentLoading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cc6ef6f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueContentLoading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var validateColor = function validateColor(color) {
  return (/^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/.test(color)
  );
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueContentLoading',

  props: {
    rtl: {
      default: false,
      type: Boolean
    },

    speed: {
      default: 2,
      type: Number
    },

    width: {
      default: 400,
      type: Number
    },

    height: {
      default: 130,
      type: Number
    },

    primary: {
      type: String,
      default: '#f0f0f0',
      validator: validateColor
    },

    secondary: {
      type: String,
      default: '#e0e0e0',
      validator: validateColor
    }
  },

  computed: {
    viewbox: function viewbox() {
      return '0 0 ' + this.width + ' ' + this.height;
    },
    formatedSpeed: function formatedSpeed() {
      return this.speed + 's';
    },
    gradientId: function gradientId() {
      return 'gradient-' + this._uid;
    },
    clipPathId: function clipPathId() {
      return 'clipPath-' + this._uid;
    },
    svg: function svg() {
      if (this.rtl) {
        return {
          transform: 'rotateY(180deg)'
        };
      }
    },
    rect: function rect() {
      return {
        style: {
          fill: 'url(#' + this.gradientId + ')'
        },
        clipPath: 'url(#' + this.clipPathId + ')'
      };
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueContentLoading: __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__["a" /* default */]
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueContentLoading: __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__["a" /* default */]
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueContentLoading: __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__["a" /* default */]
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueContentLoading: __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__["a" /* default */]
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueContentLoading: __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__["a" /* default */]
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueContentLoading: __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__["a" /* default */]
  },

  props: {
    rows: {
      default: 5,
      type: Number
    }
  },

  computed: {
    height: function height() {
      return this.rows * 21;
    }
  },

  methods: {
    getYPos: function getYPos(row, plus) {
      return plus + (row - 1) * 22;
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueContentLoading: __WEBPACK_IMPORTED_MODULE_0__VueContentLoading_vue__["a" /* default */]
  },

  props: {
    header: {
      default: true,
      type: Boolean
    },
    rows: {
      default: 5,
      type: Number
    },
    columns: {
      default: 4,
      type: Number
    }
  },

  computed: {
    height: function height() {
      return this.rows * 30 - 20;
    },
    width: function width() {
      return (this.columns - 1) * 20 + 10 + this.columns * 100;
    }
  },

  methods: {
    getXPos: function getXPos(column) {
      return 5 + (column - 1) * 100 + (column - 1) * 20;
    },
    getYPos: function getYPos(row) {
      return (row - 1) * 30;
    }
  }
});

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VueContentLoading_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_presets_Code_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_presets_List_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_presets_Twitch_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_presets_Facebook_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_presets_Instagram_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_presets_BulletList_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_presets_Table_vue__ = __webpack_require__(25);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VclCode", function() { return __WEBPACK_IMPORTED_MODULE_1__components_presets_Code_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VclList", function() { return __WEBPACK_IMPORTED_MODULE_2__components_presets_List_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VclTwitch", function() { return __WEBPACK_IMPORTED_MODULE_3__components_presets_Twitch_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VclFacebook", function() { return __WEBPACK_IMPORTED_MODULE_4__components_presets_Facebook_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VclInstagram", function() { return __WEBPACK_IMPORTED_MODULE_5__components_presets_Instagram_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VclBulletList", function() { return __WEBPACK_IMPORTED_MODULE_6__components_presets_BulletList_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VclTable", function() { return __WEBPACK_IMPORTED_MODULE_7__components_presets_Table_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VueContentLoading", function() { return __WEBPACK_IMPORTED_MODULE_0__components_VueContentLoading_vue__["a"]; });










/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__components_VueContentLoading_vue__["a" /* default */]);



/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:(_vm.svg),attrs:{"viewBox":_vm.viewbox,"preserveAspectRatio":"xMidYMid meet"}},[_c('rect',{style:(_vm.rect.style),attrs:{"clip-path":_vm.rect.clipPath,"x":"0","y":"0","width":_vm.width,"height":_vm.height}}),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":_vm.clipPathId}},[_vm._t("default",[_c('rect',{attrs:{"x":"0","y":"0","rx":"5","ry":"5","width":"70","height":"70"}}),_vm._v(" "),_c('rect',{attrs:{"x":"80","y":"17","rx":"4","ry":"4","width":"300","height":"13"}}),_vm._v(" "),_c('rect',{attrs:{"x":"80","y":"40","rx":"3","ry":"3","width":"250","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"80","rx":"3","ry":"3","width":"350","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"100","rx":"3","ry":"3","width":"400","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"120","rx":"3","ry":"3","width":"360","height":"10"}})])],2),_vm._v(" "),_c('linearGradient',{attrs:{"id":_vm.gradientId}},[_c('stop',{attrs:{"offset":"0%","stop-color":_vm.primary}},[_c('animate',{attrs:{"attributeName":"offset","values":"-2; 1","dur":_vm.formatedSpeed,"repeatCount":"indefinite"}})]),_vm._v(" "),_c('stop',{attrs:{"offset":"50%","stop-color":_vm.secondary}},[_c('animate',{attrs:{"attributeName":"offset","values":"-1.5; 1.5","dur":_vm.formatedSpeed,"repeatCount":"indefinite"}})]),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":_vm.primary}},[_c('animate',{attrs:{"attributeName":"offset","values":"-1; 2","dur":_vm.formatedSpeed,"repeatCount":"indefinite"}})])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Code_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_400b643a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Code_vue__ = __webpack_require__(14);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Code_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_400b643a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Code_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',_vm._b({attrs:{"width":300,"height":80}},'vue-content-loading',_vm.$attrs,false),[_c('rect',{attrs:{"x":"0","y":"0","rx":"3","ry":"3","width":"70","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"80","y":"0","rx":"3","ry":"3","width":"100","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"190","y":"0","rx":"3","ry":"3","width":"10","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"15","y":"20","rx":"3","ry":"3","width":"130","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"155","y":"20","rx":"3","ry":"3","width":"130","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"15","y":"40","rx":"3","ry":"3","width":"90","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"115","y":"40","rx":"3","ry":"3","width":"60","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"185","y":"40","rx":"3","ry":"3","width":"60","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"60","rx":"3","ry":"3","width":"30","height":"10"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d71da0d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(16);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d71da0d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',_vm._b({attrs:{"width":300,"height":120}},'vue-content-loading',_vm.$attrs,false),[_c('rect',{attrs:{"x":"0","y":"0","rx":"3","ry":"3","width":"250","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"20","y":"20","rx":"3","ry":"3","width":"220","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"20","y":"40","rx":"3","ry":"3","width":"170","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"60","rx":"3","ry":"3","width":"250","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"20","y":"80","rx":"3","ry":"3","width":"200","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"20","y":"100","rx":"3","ry":"3","width":"80","height":"10"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Twitch_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50166890_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Twitch_vue__ = __webpack_require__(18);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Twitch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50166890_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Twitch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',_vm._b({attrs:{"width":300,"height":225}},'vue-content-loading',_vm.$attrs,false),[_c('rect',{attrs:{"x":"0","y":"0","rx":"3","ry":"3","width":"300","height":"170"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"180","rx":"2","ry":"2","width":"35","height":"45"}}),_vm._v(" "),_c('rect',{attrs:{"x":"45","y":"180","rx":"2","ry":"2","width":"150","height":"15"}}),_vm._v(" "),_c('rect',{attrs:{"x":"45","y":"203","rx":"2","ry":"2","width":"100","height":"10"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Facebook_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db3749c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Facebook_vue__ = __webpack_require__(20);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Facebook_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db3749c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Facebook_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',_vm._b({},'vue-content-loading',_vm.$attrs,false),[_c('rect',{attrs:{"x":"0","y":"0","rx":"5","ry":"5","width":"70","height":"70"}}),_vm._v(" "),_c('rect',{attrs:{"x":"80","y":"17","rx":"4","ry":"4","width":"300","height":"13"}}),_vm._v(" "),_c('rect',{attrs:{"x":"80","y":"40","rx":"3","ry":"3","width":"250","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"80","rx":"3","ry":"3","width":"350","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"100","rx":"3","ry":"3","width":"400","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"120","rx":"3","ry":"3","width":"360","height":"10"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instagram_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_859b634c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Instagram_vue__ = __webpack_require__(22);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instagram_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_859b634c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Instagram_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',_vm._b({attrs:{"height":480}},'vue-content-loading',_vm.$attrs,false),[_c('circle',{attrs:{"cx":"30","cy":"30","r":"30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"75","y":"13","rx":"4","ry":"4","width":"100","height":"13"}}),_vm._v(" "),_c('rect',{attrs:{"x":"75","y":"37","rx":"4","ry":"4","width":"50","height":"8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"70","rx":"5","ry":"5","width":"400","height":"400"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulletList_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f52995_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BulletList_vue__ = __webpack_require__(24);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulletList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f52995_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BulletList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',_vm._b({attrs:{"width":230,"height":_vm.height}},'vue-content-loading',_vm.$attrs,false),[_vm._l((_vm.rows),function(i){return [_c('circle',{key:i + '_c',attrs:{"cx":"8","cy":_vm.getYPos(i, 8),"r":"8"}}),_vm._v(" "),_c('rect',{key:i + '_r',attrs:{"x":"22","y":_vm.getYPos(i, 3),"rx":"3","ry":"3","width":"200","height":"9"}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd8071c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__(26);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd8071c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',_vm._b({attrs:{"width":_vm.width,"height":_vm.height}},'vue-content-loading',_vm.$attrs,false),[_vm._l((_vm.rows),function(r){return [_vm._l((_vm.columns),function(c){return [_c('rect',{key:r + '_' + c,attrs:{"x":_vm.getXPos(c),"y":_vm.getYPos(r),"rx":"3","ry":"3","width":100,"height":"10"}})]}),_vm._v(" "),(r < _vm.rows)?_c('rect',{key:r + '_l',attrs:{"x":"0","y":_vm.getYPos(r) + 20,"width":_vm.width,"height":"1"}}):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// dist/vuecontentloading.js